import { createFileRoute } from '@tanstack/react-router';
import {
  bankAccountProductDetailScreen,
  productDetailSearch,
  loadBankAccountProductMessages,
  loadBankAccountProductScreens,
} from '@/modules/bank-account-product/route';
import { lazyScreen } from '@/shared/screen';
export const Route = createFileRoute('/_app/cadastro/produtos-conta/$productId/')({
  validateSearch: productDetailSearch,
  staticData: { screen: bankAccountProductDetailScreen },
  loader: loadBankAccountProductMessages,
  component: lazyScreen(loadBankAccountProductScreens, 'ProductFormPage'),
});
